'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invokeHostFunction = invokeHostFunction;

var _xdr = require('../xdr');

var _xdr2 = _interopRequireDefault(_xdr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Invokes a smart contract function
 *
 * @function
 * @alias Operation.invokeHostFunction
 *
 * @param {object} opts - options object
 * @param {xdr.HostFunction} opts.function - host function to invoke
 * @param {xdr.LedgerFootprint} [opts.footprint] - footprint of the ledger state accessed by this call
 * @param {xdr.ContractAuth[]} [opts.auth] - authorizations for the call
 *
 * @returns {xdr.Operation} an Invoke Host Function operation (xdr.InvokeHostFunctionOp)
 */
function invokeHostFunction(opts) {
  if (!opts.function) {
    throw new TypeError('function argument is required');
  }

  var invokeHostFunctionOp = new _xdr2.default.InvokeHostFunctionOp({
    function: opts.function,
    footprint: opts.footprint,
    auth: opts.auth
  });
  var opAttributes = {
    body: _xdr2.default.OperationBody.invokeHostFunction(invokeHostFunctionOp)
  };
  this.setSourceAccount(opAttributes, opts);

  return new _xdr2.default.Operation(opAttributes);
}